export default __webpack_public_path__ + "static/media/DSC_0558.c3a4fb57.webp";